import React from "react";

export default function Footer(){
    return (
        <div className="footer">
            <p>Built by : <span>Chuck Gibson</span></p>
            <p>design inspired by : <a href="https://brittanychiang.com/">Brittany Chiang</a></p>
        </div>
    )
}